import { formatNumber } from '@uikit/helpers/formatNumber';
import clsx from 'clsx';
import { useState } from 'react';
import styles from './EnergyGuzzlersQuizButton.module.scss';
import type { EnergyGuzzlersQuizButtonProps } from './types';

const CORRECT_LABELS = [
  { pre: 'Korrekt! ', post: ' Sparpotenzial 🥳' },
  { pre: 'Korrekt! Das frisst bis zu ', post: ' 😈' },
  { pre: 'Korrekt! Bis zu ', post: ' unnötiger Verbrauch ⚡️' },
  { pre: 'Korrekt! ', post: ' weniger auf dem Speiseplan! 🍴' },
  { pre: 'Korrekt! Du kannst ', post: ' sparen 😎' },
  { pre: 'Korrekt! ', post: ' weniger Futter! 🔥' },
  { pre: 'Korrekt! Bis zu ', post: ' Energiediät möglich! 💪' },
];

const getCorrectLabel = (step: number, savingsAmount: string) => {
  return (
    <>
      {CORRECT_LABELS[step % CORRECT_LABELS.length].pre}
      <strong>{savingsAmount}</strong>
      {CORRECT_LABELS[step % CORRECT_LABELS.length].post}
    </>
  );
};

const EnergyGuzzlersQuizButton = ({
  children,
  disabled,
  variant,
  onClick,
  savingsAmount,
  step = 0,
}: EnergyGuzzlersQuizButtonProps) => {
  const [isPressed, setIsPressed] = useState(false);

  const formattedSavingsAmount = `${
    savingsAmount ? formatNumber(savingsAmount) : 0
  } kWh`;

  const handleClick = () => {
    setIsPressed(true);
    if (variant === 'incorrect') {
      setTimeout(() => {
        setIsPressed(false);
      }, 2000);
    }
    onClick();
  };

  return (
    <button
      className={clsx(styles.base, {
        [styles.correct]: isPressed && variant === 'correct',
        [styles.incorrect]: isPressed && variant === 'incorrect',
      })}
      onClick={handleClick}
      disabled={disabled}
    >
      <div className={styles.inner}>
        <div className={styles.front}>{children}</div>
        <div className={styles.back}>
          <span className={styles.savingsAmount}>
            {getCorrectLabel(step, formattedSavingsAmount)}
          </span>
        </div>
      </div>
    </button>
  );
};

export default EnergyGuzzlersQuizButton;
